import React from "react";
import { EmailNotSentMoveToNextMilestoneSesciption } from "./constants";
import Button from "./Button";

export const MileStoneModal = (props) => {
  const { moveToNextMilestone, newOverviewData, emailStatus, submitStatus } =
    props;

  return (
    <div>
      <>
        <div className="fixed inset-0 bg-black-700 bg-opacity-40 flex items-center justify-center p-4">
          <div className={`bg-white rounded-lg shadow-xl max-w-md w-full p-4`}>
            <h2 className="text-lg text-gray-500 font-bold text-left">
              Email Update not Sent
            </h2>
            <p className="text-sm text-gray-400 mb-6">
              {EmailNotSentMoveToNextMilestoneSesciption}
            </p>
            <Button
              text="Move to Next Milestone"
              size="md"
              onClick={() =>
                moveToNextMilestone(newOverviewData, emailStatus, submitStatus)
              }
            />
          </div>
        </div>
      </>
    </div>
  );
};
